export default class ResetErrors
{
    /**
     * Vue Object
     */
    v = null;

    constructor(v)
    {
        this.v = v;
    }

    async handle()
    {
        this.v.orderIdentifierFormError = null;
        this.v.dispatchError = null;

        return true;
    }
}
